<template>
  <div class="youkelianggaikuang">
    <div class="top-info">
      <div class="left">
        <div class="icon"></div>
        <div class="text">
          全省旅游人数
          <span>{{ Math.round(chartData.renshu / 10000) }}</span
          >万人
        </div>
      </div>
      <div class="right">
        <div class="icon"></div>
        <div class="text">
          全省旅游人次
          <span>{{ Math.round(chartData.renci / 10000) }}</span
          >万人次
        </div>
      </div>
    </div>
    <div class="range-box">
      <div class="range" :style="{height: rangeHeight + 'rem'}">
        <div class="left" ref="shengneiyouke"></div>
        <div class="right" ref="kuashengyouke"></div>
      </div>
      <div class="info">
        <div class="left">
          省内游客
          <span>{{
            Math.round(
              (chartData.shengneiyouke /
                (chartData.shengneiyouke + chartData.kuashengyouke)) *
                100
            ) + "%"
          }}</span>
        </div>
        <div class="right">
          跨省游客
          <span>{{
            Math.round(
              (chartData.kuashengyouke /
                (chartData.shengneiyouke + chartData.kuashengyouke)) *
                100
            ) + "%"
          }}</span>
        </div>
      </div>
    </div>
    <div class="range-box">
      <div class="range" :style="{height: rangeHeight + 'rem'}">
        <div class="left" ref="shengneigeye"></div>
        <div class="right" ref="shengwaigeye"></div>
      </div>
      <div class="info">
        <div class="left">
          省内隔夜游
          <span>{{
            Math.round(
              (chartData.shengneigeye /
                (chartData.shengneigeye + chartData.shengwaigeye)) *
                100
            ) + "%"
          }}</span>
        </div>
        <div class="right">
          省外隔夜游
          <span>{{
            Math.round(
              (chartData.shengwaigeye /
                (chartData.shengneigeye + chartData.shengwaigeye)) *
                100
            ) + "%"
          }}</span>
        </div>
      </div>
    </div>
    <div class="bottom-info">
      <div class="left">
        环比上升
        <span>{{ chartData.huanbi }}</span>
      </div>
      <div class="right">
        同比上升
        <span>{{ chartData.tongbi }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "YoukeliangGaikuang",
  props: {
    chartData: {
      type: Object,
      default() {
        return null;
      }
    },
    rangeHeight: {
      type: Number,
      default: 0.12
    }
  },
  data() {
    return {};
  },
  mounted() {
    setTimeout(() => {
      this.$refs.shengneiyouke.style.width =
        Math.round(
          (this.chartData.shengneiyouke /
            (this.chartData.shengneiyouke + this.chartData.kuashengyouke)) *
            100
        ) -
        0.5 +
        "%";
      this.$refs.kuashengyouke.style.width =
        Math.round(
          (this.chartData.kuashengyouke /
            (this.chartData.shengneiyouke + this.chartData.kuashengyouke)) *
            100
        ) -
        0.5 +
        "%";
      this.$refs.shengneigeye.style.width =
        Math.round(
          (this.chartData.shengneigeye /
            (this.chartData.shengneigeye + this.chartData.shengwaigeye)) *
            100
        ) -
        0.5 +
        "%";
      this.$refs.shengwaigeye.style.width =
        Math.round(
          (this.chartData.shengwaigeye /
            (this.chartData.shengneigeye + this.chartData.shengwaigeye)) *
            100
        ) -
        0.5 +
        "%";
    }, 500);
  }
};
</script>

<style scoped lang="less">
.youkelianggaikuang .top-info {
  overflow: hidden;
}
.youkelianggaikuang .top-info .left {
  float: left;
}
.youkelianggaikuang .top-info .right {
  float: right;
}
.youkelianggaikuang .top-info > div > div {
  float: left;
}
.youkelianggaikuang .top-info .icon {
  width: 0.13rem;
  height: 0.16rem;
  background: url(../../assets/youkelianggaikuang/icon01.png);
  background-size: 100%;
  margin-right: 0.04rem;
  margin-top: 0.04rem;
}
.youkelianggaikuang .top-info .text span {
  color: #00d2fc;
  font-size: 0.18rem;
  margin: 0 0.03rem;
  font-weight: bold;
}
.youkelianggaikuang .range-box {
  width: 100%;
  overflow: hidden;
}
.youkelianggaikuang .left {
  float: left;
}
.youkelianggaikuang .right {
  float: right;
}
.youkelianggaikuang .range-box .range {
  margin: 0.22rem 0 0.2rem;
}
.youkelianggaikuang .range-box .range .left {
  width: 0%;
  height: 100%;
  background: #00ccff;
  transition: all 0.5s;
}
.youkelianggaikuang .range-box .range .right {
  width: 0%;
  height: 100%;
  background: #00d8af;
  transition: all 0.5s;
}
.youkelianggaikuang .range-box .left span {
  color: #00ccff;
  font-weight: bold;
}
.youkelianggaikuang .range-box .right span {
  color: #00d8af;
  font-weight: bold;
}
.youkelianggaikuang .bottom-info {
  margin-top: 0.28rem;
  font-weight: bold;
}
.youkelianggaikuang .bottom-info > div {
  width: 50%;
  height: 0.4rem;
  background: url(../../assets/youkelianggaikuang/btn_bg.png) no-repeat center
    center;
  background-size: 95% 100%;
  text-align: center;
  line-height: 0.4rem;
}
.youkelianggaikuang .bottom-info > div > span {
  color: #00ccff;
  font-size: 0.22rem;
  margin: 0 0.04rem;
}
</style>
